<template>
	<el-container class="forgot-view">
		<div class="w-box">
			<img class="w-logo" src="../assets//image//logo-text.png" />
		</div>
		<div>
			<el-form :model="forgotForm" status-icon :rules="rules" ref="forgotForm" label-width="80px"
				class="web-ruleForm">
				<div class="forgot-brand">
					<!-- <img class="logo" src="../../public/logo.png" /> -->
					<div>欢迎成为Aitalky的用户</div>
				</div>
				<el-form-item label="邮箱" prop="email">
					<el-input type="text" v-model.trim="forgotForm.email" autocomplete="off"
						placeholder="邮箱"></el-input>
				</el-form-item>
				<el-form-item label="密码" prop="newPassword">
					<el-input type="password" v-model.trim="forgotForm.newPassword" autocomplete="off"
						placeholder="密码"></el-input>
				</el-form-item>
				<el-form-item label="确认密码" prop="confirmPassword">
					<el-input type="password" v-model.trim="forgotForm.confirmPassword" autocomplete="off"
						placeholder="确认密码"></el-input>
				</el-form-item>
				<el-form-item label="验证码" prop="code">
					<div class="verify-code">
						<el-input type="text" v-model.trim="forgotForm.code" autocomplete="off" placeholder="邮箱验证码"></el-input>
						<el-button type="primary" :disabled="countdown > 0" @click="sendCode" class="verify-code-btn">{{ countdown > 0 ? countdown + 's后重新发送' : '获取验证码' }}</el-button>
					</div>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="submitForm('forgotForm')">提交</el-button>
					<el-button @click="resetForm('forgotForm')">清空</el-button>
				</el-form-item>
				<div class="to-login">
					<span style="color: #666666;">已有账号,<router-link class="login-link" to="/login">前往登录</router-link></span>
				</div>
			</el-form>
		</div>
		<!-- <icp></icp> -->
	</el-container>
</template>

<script>
import { initRsaPublicKey, rsaEncryptPassword } from '../utils/encrypt';
import Icp from '../components/common/Icp.vue'
export default {
	name: "login",
	components: {
		Icp
	},
	data() {
		var checkUserName = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('请输入邮箱'));
			}
			callback();
		};
		var checkCode = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('请输入验证码'));
			}
			callback();
		};
		var checkPassword = (rule, value, callback) => {
			if (value === '') {
				return callback(new Error('请输入密码'));
			}
			if (value.length < 5 || value.length > 20) {
				return callback(new Error('密码长度需在 5 到 20 位之间'));
			}
			callback();
		};

		var checkConfirmPassword = (rule, value, callback) => {
			if (value === '') {
				return callback(new Error('请输入密码'));
			}
			if (value.length < 5 || value.length > 20) {
				return callback(new Error('密码长度需在 5 到 20 位之间'));
			}
			if (value != this.forgotForm.newPassword) {
				return callback(new Error('两次密码输入不一致'));
			}
			callback();
		};


		return {
			forgotForm: {
				email: '',
				newPassword: '',
				confirmPassword: '',
				code:''
			},
			isinviteCode:false,
			rules: {
				email: [{
					validator: checkUserName,
					trigger: 'blur'
				}],
				newPassword: [{
					validator: checkPassword,
					trigger: 'blur'
				},
				{ min: 5, max: 20, message: '密码长度需在 5 到 20 位之间', trigger: 'blur' }
				],
				confirmPassword: [{
					validator: checkConfirmPassword,
					trigger: 'blur'
				},
				{ min: 5, max: 20, message: '密码长度需在 5 到 20 位之间', trigger: 'blur' }
				],
				code: [{
					validator: checkCode,
					trigger: 'blur'
				}],
			},
			countdown: 0,
			timer: null,
			code: this.$route.query.code,
		};
	},
	beforeDestroy() {
		if (this.timer) clearInterval(this.timer)
	},
	methods: {
		sendCode() {
			if(!this.forgotForm.email){
				this.$message.error('请输入邮箱')
				return
			}
			this.countdown = 60
			this.timer = setInterval(() => {
				this.countdown--
				if (this.countdown <= 0) {
					clearInterval(this.timer)
					this.timer = null
				}
			}, 1000)
			this.$http({
				url: '/sendEmailCode',
				method: 'post',
				data: {
					email: this.forgotForm.email,
				}
			})
		},
		submitForm(formName) {
			this.$refs[formName].validate(async(valid) => {
				if (valid) {
					await initRsaPublicKey();
					let data = {
						publicKey: this.$store.state.userStore.PublicKey,
						email: this.forgotForm.email,
						newPassword: rsaEncryptPassword(this.forgotForm.newPassword),
						confirmPassword: rsaEncryptPassword(this.forgotForm.confirmPassword),
						code: this.forgotForm.code,
					}
					this.$http({
						url: "/recoverPwd",
						method: 'post',
						data
					}).then((data) => {
						this.$message.success("修改成功!");
						this.$router.push({
							path: '/login'
						});
					})
				}
			});
		},
		resetForm(formName) {
			this.$refs[formName].resetFields();
		}
	}
}
</script>

<style scoped lang="scss">
.forgot-view {
	position: fixed;
	display: flex;
	justify-content: flex-end;
	align-items: center;
	width: 100%;
	height: 100%;
	padding: 10% 5%;
	background: rgb(232, 242, 255);
	background-size: cover;
	background-image: url('../assets//image//bg.png');

	.web-ruleForm {
		width: 450px;
		padding: 35px 30px;
		background: white;
		opacity: 0.9;
		box-shadow: 0px 0px 1px #ccc;
		border-radius: 3px;
		overflow: hidden;
		border-radius: 3%;

		.forgot-brand {
			display: flex;
			justify-content: center;
			align-items: center;
			line-height: 50px;
			margin: 20px 0 30px 0;
			font-size: 22px;
			font-weight: 600;
			letter-spacing: 2px;
			text-align: center;
			text-transform: uppercase;

			.logo {
				width: 30px;
				height: 30px;
				margin-right: 10px;
			}
		}

		.to-login {
			display: flex;
			justify-content: flex-end;
		}
	}
}

.login-link{
	color: #3081fe;
	text-decoration: none;
}

.verify-code{
	display: flex;
	.verify-code-btn{
		flex: 1;
		margin-left: 15px;
	}
}

.w-box{
	display: flex;
	align-items: center;
	position: absolute;
	top: 0px;
	left: 0px;

	.w-logo{
		height: 80px;
	}
}

</style>
